import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-basic',
  templateUrl: './footer-basic.component.html',
  styleUrls: []
})
export class FooterBasicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
